
import React, { useState, useEffect } from "react";
import logo from "../assets/DMGlogo.png";
import { sendAuthorizationRequest } from "../actions/sign-in";
import "../Css/Header.css";
import "../Css/RightBarDataForOtherPages.css";
import { CONFIG } from "../config";
import axios from "axios";
import CssBaseline from "@mui/material/CssBaseline";
import { AppBar, Box, Button, Toolbar } from "@mui/material";

const CommonHeaderUsers = () => {
  useEffect(() => {
    getHeaderData();
  }, []);

  const [headerLogoUrl, setHeaderLogoUrl] = useState("");
  const [headerBackGroundColor, setHeaderBackGroundColor] = useState("white");

  function getHeaderData() {
    axios(
      CONFIG.EXPERT_SERVER_URL +
        (CONFIG.SYSTEM_WITH_MENU_SYSTEM
          ? `/headerDesign/all`
          : `/pageHeaderContent/all`),
      {
        method: "get",
        headers: {
          "Content-Type": "text/plain",
        },
      }
    )
      .then(function (response) {
        (CONFIG.SYSTEM_WITH_MENU_SYSTEM
          ? response.data.filter((item) => item.systemName === CONFIG.SYSTEM_NAME)
          : response.data
        ).forEach((item) => {
          if (item.centreId === "superadmin") {
            if (item.logoUrl) setHeaderLogoUrl(item.logoUrl);
            if (item.backgroundColor) setHeaderBackGroundColor(item.backgroundColor);
          }
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const handleLoginBtnClick = (volunteerFlag) => {
    sendAuthorizationRequest(volunteerFlag);
  };

  return (
    <>
      <div>
        <Box >
          <CssBaseline />
          <AppBar
  position="fixed"
>
  <Toolbar className="toolbar"   sx={{
    backgroundColor: `${headerBackGroundColor}`, 
    height: "100px",
    textDecoration:"none"
  }}>
    <div className="" >
      {headerLogoUrl ? (
        <img src={headerLogoUrl} alt="Header Logo" className="header-logo" />
      ) : (
        <img src={logo} alt="Default Logo" className="header-logo" />
      )}
    </div>
    <div
  className="nav-container"
  style={{
    textDecoration: "none",
  }}
>
  <div 
    className="navList"
    style={{
      display: "flex",
      gap: "20px",
      alignItems: "center",
      textDecoration:'none'
    }}
  >
  
      <a href="/" className="link">HOME</a>
  
  
      <a href="/aboutus" className="link">ABOUT US</a>

    
      <a href="/ourservices" className="link">OUR SERVICES</a>
  
    
      <a href="/pricingsp" className="link">PRICING</a>
 
   
      <a href="/blog" className="link">BLOG</a>
   
   
      <Button
        variant="contained"
        size="medium"
        onClick={() => handleLoginBtnClick(true)}
        sx={{
          background: "linear-gradient(270deg, #9155FD 0%, #C6A7FE 100%)",
          color: "#fff",
          fontSize: {
            xs: '7px',
            sm: '10px',
            md: '14px',
          },
        }}
      >
        Login
      </Button>
   
  
</div>
</div>

  </Toolbar>
</AppBar>

        </Box>
      </div>
    </>
  );
};

export default CommonHeaderUsers;
